<template>
  <div>
    <v-toolbar fixed color="#23a7d2" dark>
      <v-btn @click="drawer = true" icon>
        <v-icon>menu</v-icon>
      </v-btn>

      <img src="../../assets/logo.png" style="width:10%;height:auto" class="logo" />

      <v-btn
        flat
        dark
        x-large
        v-if="this.$store.state.user.type.id == 1"
        :to="{name:'pendingRequests'}"
      >درخواست های در صف</v-btn>

      <v-spacer></v-spacer>

      <v-btn :to="{name: 'index'}" icon>
        <v-icon>home</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon>local_post_office</v-icon>
      </v-btn>
      <v-btn flat dark x-large v-if="!this.$store.state.isUserLoggedIn" :to="{name:'login'}">ورود</v-btn>
      <v-menu
        v-if="this.$store.state.isUserLoggedIn"
        bottom
        origin="center center"
        transition="slide-x-transition"
      >
        <v-btn flat slot="activator">
          <v-icon>account_circle</v-icon>&nbsp;
          <span>{{ this.$store.state.user.name }}</span>
          <v-icon small>arrow_drop_down</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile key="EditProfile" @click="PwdConfrim = true">
            <v-list-tile-title class="text-xs-right">
              <v-icon>lock</v-icon>&nbsp;
              ویرایش رمز عبور
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile key="logout" @click="logout">
            <v-list-tile-title class="text-xs-right">
              <v-icon>power_settings_new</v-icon>&nbsp;
              خروج
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <!-----------------------------navigation menu--------------------------->

    <v-navigation-drawer fixed v-model="drawer" :mini-variant="mini" absolute right temporary>
      <v-list class="pa-1">
        <v-list-tile v-if="mini" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>chevron_left</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <!----------------------------------------------------->
        <v-list-tile avatar tag="div">
          <v-avatar>
            <img :src="this.$store.state.user.name" alt="John" />
          </v-avatar>
          <!-- <v-list-tile-avatar>
            <img src="../img/abbas.jpg">
          </v-list-tile-avatar>-->
          <v-spacer></v-spacer>
          <v-list-tile-action>
            <v-btn icon @click.stop="mini = !mini" style="margin-right: 26px;">
              <v-icon color="primary">chevron_right</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <!----------------------------------------------------->
        <!----------------------------------------------------->
        <v-list-tile tag="div">
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-right" color="grey darken-3">به پنل مدیریت خوش آمدید</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!----------------------------------------------------->
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider light></v-divider>

        <v-list-tile
          :to="{name: item.route}"
          v-for="item in activeItems"
          :key="item.title"
        >
          <v-list-tile-action>
            <v-icon color="pink">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title class="text-xs-right">{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-----------------------------navigation menu--------------------------->
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: null,
      mini: false,
      items: [
        { title: "داشبورد", icon: "dashboard", route: "home", type: 1 },
        {
          title: "مدیریت نمایندگان فروش",
          icon: "question_answer",
          route: "agent",
          type: 1
        },
        {
          title: "ایجاد اخبار",
          icon: "question_answer",
          route: "news",
          type: 1
        },
        {
          title: "ایجاد اخبار",
          icon: "question_answer",
          route: "news",
          type: 2
        },
        {
          title: "مدیریت داوران",
          icon: "question_answer",
          route: "referee",
          type: 2
        },
        {
          title: "مدیریت کلاس دهی ",
          icon: "question_answer",
          route: "classification",
          type: 1
        },
        { title: "مدیریت مسیرها ", icon: "question_answer", type: 2 },
        { title: "مدیریت نقطه ها", icon: "question_answer", type: 2, route: "point" }
      ]
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setToken", null);
      this.$router.go();
    }
  },
  mounted() {
    if (!this.$store.state.isUserLoggedIn) {
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    activeItems: function() {
      return this.items.filter(i => this.$store.state.user.type.id == i.type);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-list__tile__title {
  text-align: right;
}
</style>
